import React, { useState } from 'react';
import pdf_1_icon from '../pdf/1/icon.png'
import pdf_2_icon from '../pdf/2/icon.png'
import pdf_3_icon from '../pdf/3/icon.png'
import pdf_4_icon from '../pdf/4/icon.png'
import image_1 from '../image/1/icon.png'
import image_2 from '../image/2/icon.png'
import video_1 from '../video/video_1.png'
import video_2 from '../video/video_2.png'
import video_3 from '../video/video_3.jpg'

import SliderCarousel from "./ImageCarousel"
import Modal from '../../components/Modal';
import { getGHTPdf, getGHTSlider } from '../../version3/SliderFiles';
import Slider from '../../components/Slider';
import { analyticsUserTrack } from '../../config/analyticsTrack';



const bioImages = [
    { file: image_1, uniqueId: "1", extType: "image" },
    { file: image_2, uniqueId: "2", extType: "image" },
    { file: pdf_1_icon, uniqueId: "3", extType: "pdf" },
    { file: pdf_2_icon, uniqueId: "4", extType: "pdf" },
    { file: pdf_3_icon, uniqueId: "5", extType: "pdf" },
    { file: pdf_4_icon, uniqueId: "6", extType: "pdf" },
    { file: video_3, uniqueId: "7", extType: "video", youtubeUrl: "https://www.youtube.com/embed/oW1KZUSN9o8" },
    { file: video_1, uniqueId: "8", extType: "video", videoUrl: "https://tv.teqbahn.com/teqitTv-api/files?processType=assets&fileName=GHT-Jun2024.mp4" },
    { file: video_2, uniqueId: "9", extType: "video", videoUrl: "https://tv.teqbahn.com/teqitTv-api/files?processType=assets&fileName=GHT-WG-Jul2024INTRO.mp4" }
]

export default function LearnAboutUs() {
    let [active, setActive] = useState(null);
    let activeData = {};
    if (active) {
        let findindex = bioImages.findIndex((fe) => fe.uniqueId === active)
        if (findindex !== -1) {
            activeData = bioImages[findindex]
        }

    }
    function viewModalData() {
        let { extType, youtubeUrl, videoUrl, file } = activeData
        let returnText = ""
        switch (extType) {
            case "video":
                if (youtubeUrl) {
                    returnText = <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', height: "60vh" }}>
                        <iframe
                            title="YouTube Video"
                            src={youtubeUrl}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%'

                            }}
                        ></iframe>
                    </div>
                } else if (videoUrl) {
                    returnText = <div className="embed-responsive" style={{ height: "80vh" }}>
                        <video className="embed-responsive-item" controls poster={file}>
                            <source src={videoUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                }
                break;
            case "image":
                returnText = <Slider slider={getGHTSlider(active, "80vh")} />
                break;
            case "pdf":
                returnText = getGHTPdf(active, window.innerHeight - 200)
                break;
            default:
                returnText = ""
                break;
        }
        return returnText

    }
    return <React.Fragment>
        <div className='learn-about-us'>
            <SliderCarousel images={bioImages} sliderOnclick={(id) => {
                setActive(id)
                analyticsUserTrack("GHT", "Learn About US - "+id);
            }} />
        </div>
        {
            active && <Modal
                visible={active ? true : false}
                closeModal={() => {
                    setActive("")
                }}
                heading={""}
                size={"modal-xl"}
                body={<React.Fragment>
                    {viewModalData()}
                </React.Fragment>
                }
                footer={<button className='btn btn-sm btn-primary' style={{ cursor: "pointer" }} onClick={() => {
                    setActive("")
                }}>Close</button>}
            />
        }
    </React.Fragment>;
}
